import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { teamMembers } from '../data/mock';
import { 
  MapPin, Phone, Mail, Clock, Send, 
  MessageSquare, Calendar, User 
} from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    preferredContact: 'email',
    propertyInterest: 'buying'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We\'ll get back to you within 24 hours.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      preferredContact: 'email',
      propertyInterest: 'buying'
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-[#E2725B] to-[#FF914D] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            LET'S TALK ABOUT YOUR NEXT HOME
          </h1>
          <p className="text-xl md:text-2xl leading-relaxed">
            Ready to begin your property journey? Our experts are here to help
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <Card>
              <CardHeader>
                <CardTitle className="text-3xl font-bold" style={{ color: '#2E2E2E' }}>
                  Send Us A Message
                </CardTitle>
                <p className="text-gray-600">
                  Fill out the form below and we'll get back to you within 24 hours
                </p>
              </CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Full Name *
                      </label>
                      <Input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="your.email@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <Input
                        id="phone"
                        name="phone"
                        type="tel"
                        placeholder="+44 20 xxxx xxxx"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full"
                      />
                    </div>
                    <div>
                      <label htmlFor="propertyInterest" className="block text-sm font-medium text-gray-700 mb-2">
                        I'm Interested In
                      </label>
                      <select
                        id="propertyInterest"
                        name="propertyInterest"
                        value={formData.propertyInterest}
                        onChange={handleChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#E2725B] focus:border-transparent"
                      >
                        <option value="buying">Buying</option>
                        <option value="selling">Selling</option>
                        <option value="renting">Renting</option>
                        <option value="letting">Letting</option>
                        <option value="investment">Investment</option>
                        <option value="valuation">Property Valuation</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                      Subject
                    </label>
                    <Input
                      id="subject"
                      name="subject"
                      type="text"
                      placeholder="What can we help you with?"
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message *
                    </label>
                    <Textarea
                      id="message"
                      name="message"
                      placeholder="Please provide details about your property needs, preferred locations, budget range, or any specific questions you have..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="w-full min-h-[120px]"
                    />
                  </div>

                  <div>
                    <label htmlFor="preferredContact" className="block text-sm font-medium text-gray-700 mb-2">
                      Preferred Contact Method
                    </label>
                    <select
                      id="preferredContact"
                      name="preferredContact"
                      value={formData.preferredContact}
                      onChange={handleChange}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#E2725B] focus:border-transparent"
                    >
                      <option value="email">Email</option>
                      <option value="phone">Phone</option>
                      <option value="both">Both Email & Phone</option>
                    </select>
                  </div>

                  <Button 
                    type="submit"
                    className="w-full bg-gradient-to-r from-[#E2725B] to-[#FF914D] hover:from-[#d65a43] hover:to-[#e8823d] text-white py-3 text-lg font-semibold flex items-center justify-center gap-2"
                  >
                    <Send className="h-5 w-5" />
                    Send Message
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Office Info */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2" style={{ color: '#2E2E2E' }}>
                  <MapPin className="h-5 w-5 text-[#E2725B]" />
                  Visit Our Office
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <p className="font-medium" style={{ color: '#2E2E2E' }}>Elite Real Estate</p>
                  <p className="text-gray-600">
                    123 Mayfair Street<br />
                    London W1K 6RQ<br />
                    United Kingdom
                  </p>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <Phone className="h-4 w-4 text-[#E2725B]" />
                    <a href="tel:+442071234567" className="text-gray-700 hover:text-[#E2725B] transition-colors">
                      +44 20 7123 4567
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="h-4 w-4 text-[#E2725B]" />
                    <a href="mailto:info@eliterealestate.com" className="text-gray-700 hover:text-[#E2725B] transition-colors">
                      info@eliterealestate.com
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Clock className="h-4 w-4 text-[#E2725B]" />
                    <span className="text-gray-700">Mon-Fri: 9AM-7PM, Sat: 10AM-5PM</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Quick Actions */}
            <Card>
              <CardHeader>
                <CardTitle style={{ color: '#2E2E2E' }}>
                  Need Immediate Assistance?
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <Button 
                  className="w-full bg-gradient-to-r from-[#E2725B] to-[#FF914D] hover:from-[#d65a43] hover:to-[#e8823d] text-white flex items-center justify-center gap-2"
                  asChild
                >
                  <a href="tel:+442071234567">
                    <Phone className="h-4 w-4" />
                    Call Now
                  </a>
                </Button>
                <Button 
                  variant="outline" 
                  className="w-full flex items-center justify-center gap-2"
                  asChild
                >
                  <a href="mailto:info@eliterealestate.com">
                    <Mail className="h-4 w-4" />
                    Email Us
                  </a>
                </Button>
                <Button 
                  variant="outline" 
                  className="w-full flex items-center justify-center gap-2"
                >
                  <Calendar className="h-4 w-4" />
                  Book Viewing
                </Button>
                <Button 
                  variant="outline" 
                  className="w-full flex items-center justify-center gap-2"
                >
                  <MessageSquare className="h-4 w-4" />
                  Live Chat
                </Button>
              </CardContent>
            </Card>

            {/* Emergency Contact */}
            <Card className="bg-gradient-to-r from-[#E2725B] to-[#FF914D] text-white">
              <CardContent className="p-6">
                <h3 className="font-bold text-lg mb-2">24/7 Emergency Line</h3>
                <p className="mb-4">For urgent property matters outside office hours</p>
                <Button 
                  className="w-full bg-white text-[#E2725B] hover:bg-gray-100 flex items-center justify-center gap-2"
                  asChild
                >
                  <a href="tel:+442071234999">
                    <Phone className="h-4 w-4" />
                    +44 20 7123 4999
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Team Section */}
        <section className="mt-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#2E2E2E' }}>
              Meet Your Property Experts
            </h2>
            <p className="text-xl text-gray-600">
              Connect directly with our specialist team members
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamMembers.map((member) => (
              <Card key={member.id} className="text-center hover:shadow-lg transition-shadow duration-300">
                <CardContent className="p-6">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                  />
                  <h3 className="font-bold mb-1" style={{ color: '#2E2E2E' }}>
                    {member.name}
                  </h3>
                  <p className="text-[#E2725B] text-sm font-medium mb-3">
                    {member.position}
                  </p>
                  <div className="flex justify-center space-x-2">
                    <Button 
                      size="sm" 
                      variant="outline"
                      asChild
                    >
                      <a href={`mailto:${member.email}`}>
                        <Mail className="h-4 w-4" />
                      </a>
                    </Button>
                    <Button 
                      size="sm" 
                      variant="outline"
                      asChild
                    >
                      <a href={`tel:${member.phone}`}>
                        <Phone className="h-4 w-4" />
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* Map Section */}
        <section className="mt-20">
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#2E2E2E' }}>Find Us</CardTitle>
              <p className="text-gray-600">Located in the heart of Mayfair, London</p>
            </CardHeader>
            <CardContent>
              <div className="w-full h-96 bg-gray-200 rounded-lg flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <MapPin className="h-12 w-12 mx-auto mb-4" />
                  <p className="text-lg font-medium">Interactive Map</p>
                  <p className="text-sm">123 Mayfair Street, London W1K 6RQ</p>
                  <p className="text-sm mt-2">
                    <a 
                      href="https://maps.google.com/?q=123+Mayfair+Street+London+W1K+6RQ" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#E2725B] hover:underline"
                    >
                      View in Google Maps
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default Contact;